<div mat-dialog-title class="header-grid">
  <b>{{ 'Courses.LinkConfiguration' | translate }}</b>
  <div>
    <button mat-button mat-dialog-close class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content>
  <div class="grid">
    <div class="side-params">
      @if (searchMode) {
        <div id="search">
          <mat-form-field class="full-width" appearance="outline">
            <input matInput [(ngModel)]="searchInput" (keyup)="performSearch($event)" [placeholder]="'Courses.SearchContent' | translate" />
          </mat-form-field>
          @if (searchRes.length > 0 && searchInput.length > 0) {
            <div
              class="result-box"
              cdkDropList
              #searchList="cdkDropList"
              [cdkDropListData]="searchRes.slice(0, 5)"
              [id]="'cdk-drop-list-search'"
              [cdkDropListConnectedTo]="[childrenList, parentList]"
              (cdkDropListDropped)="drop($event)"
            >
              <b>{{ 'Global.DragAndDropItem' | translate }}</b>
              @for (item of searchRes.slice(0, 5); track item) {
                <div class="result-item" [innerHTML]="highlight(item.lecture.name, searchInput)" cdkDrag></div>
              }
            </div>
          }
        </div>
      }
      @if (editMode) {
        <div id="edit">
          <div class="edit-box">
            <b>{{ chosenItem.item.lecture.name }}</b>
            @if (chosenItem.item.attachments) {
              <div>
                @if (chosenItem.item.attachments.length) {
                  <div>
                    <h3>Attachments :</h3>
                    @for (attachment of chosenItem.item.attachments; track attachment) {
                      <div>
                        {{ attachment.filename }}
                        <a mat-raised-button color="primary" [href]="attachment.attachmentLink">
                          {{ 'Global.Download' | translate }}
                        </a>
                        <a mat-raised-button color="warn" (click)="deleteAttachment(attachment)">
                          {{ 'Global.Delete' | translate }}
                        </a>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="add-attachments">
              <app-file-uploader [urlPath]="'course_link_attachment/'" [type]="'mini-uploader'" [params]="getParam(chosenItem.item)" (success)="onAttachmentUploaded($event)"></app-file-uploader>
            </div>
            <div class="add-link-footer">
              <div class="flex-grow-item">
                <div class="btn-wrapper">
                  <button mat-button (click)="switchToSearchMode()">
                    {{ 'Courses.BackToSearch' | translate }}
                  </button>
                </div>
                <span class="flex-grow-item"></span>
                <div class="btn-wrapper">
                  <button mat-flat-button color="warn" (click)="delete(chosenItem.item)">
                    {{ 'Global.Delete' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="p-dsplyr">
      <div
        class="p-dsplyr-bx drop-list"
        cdkDropList
        #parentList="cdkDropList"
        [cdkDropListData]="parents"
        [cdkDropListConnectedTo]="[childrenList]"
        [id]="'Parent'"
        (cdkDropListDropped)="drop($event)"
      >
        <b>{{ 'Courses.Parents' | translate }}</b>
        @for (element of parents; track element) {
          <div class="p-dsplyr-item drag-item" cdkDrag (click)="editItem(element)">
            <div>{{ element.item.lecture.name }}</div>
            <div class="drag-handle" cdkDragHandle>
              <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            </div>
          </div>
        }
      </div>

      <div class="p-dsplyr-bx" cdkDropList #childrenList="cdkDropList" [cdkDropListData]="children" [cdkDropListConnectedTo]="[parentList]" [id]="'Child'" (cdkDropListDropped)="drop($event)">
        <b>{{ 'Courses.Children' | translate }}</b>
        @for (element of children; track element) {
          <div class="p-dsplyr-item drag-item" cdkDrag (click)="editItem(element)">
            <div>{{ element.item.lecture.name }}</div>
            <div class="drag-handle" cdkDragHandle>
              <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
